/*
 * Lazily fills the country popouts rendered by snippets/localization.liquid.
 *
 * The full country list is rendered once per page in
 * <template id="LocalizationCountryOptions"> (see the layouts). Each country
 * popout starts with an empty [data-country-options] list; the first time a
 * visitor hovers, focuses or clicks the popout we clone the template into it.
 *
 * Loaded as type="module", so it executes only once even though every
 * localization snippet on the page includes the script tag.
 */
(function () {
  'use strict';

  const TEMPLATE_ID = 'LocalizationCountryOptions';
  const LIST_SELECTOR = '[data-country-options]';

  function fillList(list) {
    if (!list || list.hasAttribute('data-country-options-filled')) return;

    const template = document.getElementById(TEMPLATE_ID);
    if (!template) return;

    const fragment = template.content.cloneNode(true);

    if (list.hasAttribute('data-hide-flags')) {
      fragment.querySelectorAll('.popout__flag').forEach((flag) => flag.remove());
    }

    // Keep the static entries rendered in Liquid (US redirect) at the end
    list.prepend(fragment);
    list.setAttribute('data-country-options-filled', '');
  }

  // Fill on first intent. Capture phase on document runs before the
  // popout's own toggle click handler, so the list is complete before it is
  // measured and shown.
  function onIntent(event) {
    const popout = event.target.closest && event.target.closest('popout-select');
    if (popout) fillList(popout.querySelector(LIST_SELECTOR));
  }

  ['pointerover', 'focusin', 'click'].forEach((type) => {
    document.addEventListener(type, onIntent, {capture: true, passive: true});
  });

  // popout-select binds option handlers when it connects, before these
  // options exist, so handle selection here (same behaviour as a "submit"
  // popout in theme.js: set the hidden input and submit the form).
  document.addEventListener('click', (event) => {
    const option = event.target.closest && event.target.closest(`${LIST_SELECTOR} [data-popout-option]`);
    if (!option || option.getAttribute('href') !== '#') return;

    event.preventDefault();

    const popout = option.closest('popout-select');
    const input = popout && popout.querySelector('[data-popout-input]');
    if (!input) return;

    input.value = option.getAttribute('data-value') || '';
    input.removeAttribute('disabled');

    const form = popout.closest('form');
    if (form) form.submit();
  });
})();
